import { useState } from 'react';
import { loginRequest } from '../services/apiClient';

const idleStatus = { type: 'idle', message: '' };

export default function useAuth() {
  const [token, setToken] = useState('');
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [status, setStatus] = useState(idleStatus);

  const login = async ({ userId, password }) => {
    const trimmedUserId = userId?.trim() || '';
    const trimmedPassword = password?.trim() || '';

    if (!trimmedUserId || !trimmedPassword) {
      setStatus({
        type: 'error',
        message: 'الرجاء إدخال رقم المستخدم وكلمة المرور.',
      });
      return false;
    }

    setStatus({ type: 'loading', message: 'جاري تسجيل الدخول...' });

    try {
      const result = await loginRequest({
        userId: trimmedUserId,
        password: trimmedPassword,
      });

      setToken(result.token);
      setUser(result.user);
      setRoles(result.roles || []);
      setStatus({ type: 'success', message: 'تم تسجيل الدخول بنجاح.' });
      return true;
    } catch (error) {
      setStatus({
        type: 'error',
        message: error.message || 'تعذر الاتصال بالخادم.',
      });
      return false;
    }
  };

  const logout = () => {
    setToken('');
    setUser(null);
    setRoles([]);
    setStatus(idleStatus);
  };

  const hasRole = (roleName) => roles.includes(roleName);

  return {
    token,
    user,
    roles,
    status,
    login,
    logout,
    hasRole,
  };
}

